module.exports = __webpack_public_path__ + "static/assets/5b3f10d704f9ac612ebf15b8f8caba81.png";